// extracted by mini-css-extract-plugin
export const content = "about-Me-module--content--19Jo-";
export const myParagraph = "about-Me-module--myParagraph--2CUK6";